// The page editor open now, for what the board does from outside it: a widget added from the gallery goes
// in after the block the cursor was in (or the one the slash menu was opened on), and a widget removed from
// its own menu takes its block with it. Light on purpose: the main app loads it, never the editor.

import type { ID } from "../../../shared/types";

export interface LiveEditor {
  boardId: ID;
  pageId: ID;
  /** puts a widget's block in the page, after the chosen block, and gives the page's body with it */
  placeWidget(itemId: ID): unknown;
  /** takes a widget's block out of the page, which takes the widget with it in one step; false when it holds none */
  removeWidget(itemId: ID): boolean;
}

let live: LiveEditor | null = null;

export function setLive(e: LiveEditor | null) {
  live = e;
}

export function liveEditor(): LiveEditor | null {
  return live;
}
